/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientPoint {
    angular.module("meevo.plugins.clientPoint", []);
}